module.exports = __webpack_public_path__ + "img/2.f5ce3cc1.jpg";